module.exports = __webpack_public_path__ + "static/media/C_S03.c93ccc03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_S03.png
// module id = 128
// module chunks = 0